import { validatePassword, getStrengthColor } from '../lib/passwordValidator'

export default function PasswordStrength({ password }) {
  if (!password) return null

  const { rules, strength, passedCount } = validatePassword(password)
  const color = getStrengthColor(strength)
  const percent = (passedCount / rules.length) * 100

  return (
    <div style={{ marginTop: 4 }}>
      <div style={{ display: 'flex', gap: 4, alignItems: 'center', marginBottom: 8 }}>
        <div style={{
          flex: 1, height: 5, borderRadius: 999,
          background: 'var(--color-border)', overflow: 'hidden',
        }}>
          <div style={{
            height: '100%', width: `${percent}%`, background: color,
            borderRadius: 999, transition: 'width 0.3s ease, background 0.3s ease',
          }} />
        </div>
        <span style={{
          fontSize: 11, fontWeight: 600, color: color,
          textTransform: 'uppercase', letterSpacing: 0.5, minWidth: 42,
        }}>{strength}</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {rules.map((rule) => (
          <div key={rule.id} style={{
            display: 'flex', alignItems: 'center', gap: 6,
            fontSize: 12,
            color: rule.passed ? 'var(--color-success)' : 'var(--color-muted)',
            transition: 'color 0.2s',
          }}>
            <span style={{ fontSize: 10 }}>{rule.passed ? '✅' : '○'}</span>
            {rule.label}
          </div>
        ))}
      </div>
    </div>
  )
}